//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonCard from "../CommonCard";
import Row from "../CommonRow";
export default {
  components: { CommonCard, Row },
  data() {
    return {
      data: [15, -15, 30],
    };
  },
  computed: {
    filterData() {
      // 把最大的用100%展示，其他的依照最大的算百分比
      let list = this.data.map((v) => Math.abs(v));
      let max = Math.max(...list);
      if (max > 100) {
        return list.map((v) => (v / max) * 100 + "%");
      } else {
        return list.map((v) => (v / 100) * 100 + "%");
      }
    },
  },
  methods: {
    toDetail() {
      this.$router.push;
    },
  },
};
